import PlurallClient from '@plurall/client'
import { getToken } from './token'

const plurallClient = () => {
  try {
    const authToken = getToken()

    const baseConfig = {
      apiURL: process.env.REACT_APP_PLURALL_API_URL,
      graphqlURL: process.env.REACT_APP_SOMOS_GRAPHQL_URL,
      applicationId: process.env.REACT_APP_ID_APPLICATION,
    }

    const authConfig = { accessToken: authToken }

    const noAuthConfig = { useTokenValidation: false }

    const tokenValidationConfig = authToken ? authConfig : noAuthConfig

    return new PlurallClient({
      ...baseConfig,
      ...tokenValidationConfig,
    })
  } catch (e) {
    return null
  }
}

const graphqlClient = () => {
  try {
    const { graphqlClient } = plurallClient()

    return graphqlClient
  } catch (e) {
    return null
  }
}

const handleGraphQLErrors = (graphQLErrors) => {
  if (graphQLErrors) {
    return graphQLErrors.map((error) => error.message)
  }

  return ['Ocorreu um erro inesperado. Tente novamente mais tarde.']
}

const handleGraphQLErrorsWithString = (errors, defaultError) => {
  if (errors?.graphQLErrors) {
    return errors?.graphQLErrors?.map(({ message }) => message).join(' ')
  }

  return defaultError
}

const handleGraphQLErrorsWithToast = (errors, defaultError) => {
  if (errors?.graphQLErrors) {
    return errors?.graphQLErrors?.map(({ message }) =>
      window.PLURALL_ELO_TOAST_CONTAINER.addToast({
        variant: 'negative',
        text: message,
      }),
    )
  }
  return window.PLURALL_ELO_TOAST_CONTAINER.addToast({
    variant: 'negative',
    text: defaultError,
  })
}

const graphQLMutate = async (mutation, options) => {
  const { data } = await graphqlClient().mutate({
    mutation,
    ...options,
  })

  return { data }
}

const graphQLQuery = async (query, options) => {
  const { data } = await graphqlClient().query({
    query,
    ...options,
  })

  return { data }
}

export {
  graphqlClient,
  handleGraphQLErrors,
  handleGraphQLErrorsWithToast,
  graphQLMutate,
  handleGraphQLErrorsWithString,
  graphQLQuery,
  plurallClient,
}
